import { SharedAngular } from '@Client/@types/sharedAngular';
import IProcedureDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureDetail';
import angular from 'angular';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { ProcedureViewMode } from '@Shared.Angular/@types/core/contracts/constants/procedureViewMode';
import { ProcedureApiService } from '@Shared.Angular/flowingly.services/procedure.api.service';
import { ProcedureEnhancementState } from '@Shared.Angular/@types/core/contracts/constants/procedureEnhancementState';
import { IProcedureUpdatedMessage } from '@Shared.Angular/@types/pubSub';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

class ProcedureController {
  static $inject = [
    'procedure',
    'APP_CONFIG',
    '$state',
    '$stateParams',
    '$window',
    'procedureApiService',
    'notificationService',
    'pubsubService'
  ];
  public editorMode: ProcedureViewMode;
  subscriberId = 'procedure-editor';
  private backLinkState: string;

  constructor(
    private procedure: IProcedureDetail,
    private APP_CONFIG: SharedAngular.APP_CONFIG,
    private $state: IStateService,
    private $stateParams: IStateParamsService,
    private $window: ng.IWindowService,
    private procedureApiService: ProcedureApiService,
    private notificationService: SharedAngular.NotificationService,
    private pubsubService: SharedAngular.PubSubService
  ) {
    const viewMode = parseInt($stateParams.viewMode, 10);
    if (!APP_CONFIG.enableProcedures) {
      $state.go(STATE_MAPPINGS.flowsactive);
    } else if (!procedure.userCanEdit && viewMode === ProcedureViewMode.Edit) {
      $state.go(STATE_MAPPINGS.librarydrafts);
    }

    if (
      $stateParams.aiEnhance === 'true' &&
      this.APP_CONFIG.enableProcedureAiEnhancement &&
      this.procedure.enhancementState === ProcedureEnhancementState.NotEnhanced
    ) {
      this.procedure.enhancementState = ProcedureEnhancementState.InProgress;
      this.procedureApiService
        .enhanceProcedure(this.procedure.id)
        .then(() => {
          this.notificationService.showSuccessToast(
            'SOP enhancement complete.'
          );
        })
        .catch(() => {
          this.notificationService.showErrorToast(
            'SOP enhancement failed. Please try again later.'
          );
          this.procedure = {
            ...this.procedure,
            enhancementState: ProcedureEnhancementState.NotEnhanced
          };
        });
    }

    if (
      this.procedure.enhancementState === ProcedureEnhancementState.InProgress
    ) {
      this.pubsubService.subscribe(
        'PROCEDURE_UPDATED',
        (event, message: IProcedureUpdatedMessage) => {
          if (message.overview.id !== this.procedure.id) {
            return;
          }
          this.procedureApiService
            .getProcedure(this.procedure.id, this.$stateParams.viewMode)
            .then((updatedProcedure) => {
              this.procedure = updatedProcedure;
              this.pubsubService.unsubscribeAll(this.subscriberId);
            });
        },
        this.subscriberId
      );
    }

    this.editorMode =
      viewMode === ProcedureViewMode.Edit
        ? ProcedureViewMode.Edit
        : viewMode === ProcedureViewMode.PublishRequest
        ? ProcedureViewMode.PublishRequest
        : ProcedureViewMode.ReadOnly;
    this.backLinkState =
      this.editorMode === ProcedureViewMode.ReadOnly
        ? STATE_MAPPINGS.procedures
        : procedure.published
        ? STATE_MAPPINGS.libraryprocedures
        : STATE_MAPPINGS.librarydrafts;
    $window.document.title = 'SOP - ' + procedure.name;
  }

  $onDestroy() {
    this.pubsubService.unsubscribeAll(this.subscriberId);
  }
}

angular
  .module('flowingly.runner.procedures')
  .controller('procedureController', ProcedureController);
